// Read and write a point based model's rules, outside the store.
//
// Follows `leafGridApi.ts`: one page reads and writes this. The store's
// `groupsPointBasedRules` is loaded once and kept, so it goes stale the moment
// anything else (an agent, another tab) writes the rules; this page asks the
// server each time it mounts instead, and clears that copy after each write so
// the unflagged page re-reads it.
import axios from 'axios';

import { PointRuleGroup } from './pointRules';

export async function fetchPointRules(
  tenant: string | number,
  modelId: string | number
): Promise<PointRuleGroup[]> {
  const { data } = await axios.get(
    `/api/tenant/${tenant}/model/${modelId}/pointBasedRules`
  );
  return Array.isArray(data) ? (data as PointRuleGroup[]) : [];
}

/**
 * Write the whole document. Null on success, else what the server said: the
 * route validates by compiling the rules and running them, so a refusal names
 * a SQL problem the page could not see.
 */
export async function savePointRules(
  tenant: string | number,
  modelId: string | number,
  groups: PointRuleGroup[]
): Promise<string | null> {
  try {
    await axios.put(
      `/api/tenant/${tenant}/model/${modelId}/pointBasedRules`,
      groups
    );
    return null;
  } catch (error) {
    return (
      error?.response?.data?.message ??
      'These rules could not be saved. Your changes are still on the page.'
    );
  }
}
